import React, { useEffect, useState } from "react";
import Breadcrumb from "../../Components/Utils/Breadcrumb";
import { Link, Outlet, useLocation, useParams } from "react-router-dom";
import { GetDashboardRole } from "../../Components/Utils/roles";
import { useNumber } from "../../Context/ProjectIdContext";
import axiosInstance from "../../Services/axiosCommon";
import { Select } from "antd";

const DashboardLayout = (
    {
        getData=() => {},
    }
) =>{
    const location = useLocation();
    let pathFile = location.pathname;
    const {officeId} = useParams();
        const [projectList,setProjectList]= useState([])
    
    let LinkItem = [
        {
            label:"Overall",
            link:`/dashboard`,
            access:GetDashboardRole(""),
        },
        {
            label:"Calendar",
            link:`/dashboard/calender`,
            access:GetDashboardRole(""),
        },
        
    ]

    const {number, updateNumber} = useNumber()

  

    function handleProjectChange(e){
        console.log(e);
        updateNumber(e)
    }

  return (
    <div className=" w-full h-full  px-4 py-2 overflow-hidden">
      {/* <Breadcrumb items={[]} /> */}

      <div className="w-[100%] h-[calc(100vh-90px)] mt-2">
        <div className="flex w-full gap-4 lg:mr-3">
        {/* <div className=" h-8 flex items-center gap-x-1 "> */}
  <div className="w-full flex items-center gap-x-1">
   {LinkItem &&
     LinkItem.map((item, i) => {
       const isActive = item?.link === pathFile;
       return (
        <>

                    <Link
                      to={item?.link}
                      key={item?.link}
                      className={`px-4 py-1 rounded-t-md text-xs 2xl:text-sm font-medium mt-0.5
                        ${isActive 
                          ? "bg-baseColor-primary text-white" 
                          : "bg-white text-baseColor-primary border-b-2 border-baseColor-primary"
                        }`}
                    >
                      {item?.label || ""}
                    </Link>
                
        
        </>
       );
     })}
 </div>
 
{/* </div> */}

        {
  pathFile === `/dashboard/project` && (

        <form className=" w-full flex" onSubmit={getData}>
        <div className="text-baseColor-primary  text-xs 2xl:text-sm font-medium lg:flex mt-1 hidden ">
           {/*  <p>Project</p> */}
            {/* <p className="pr-2">:</p>  */}
            </div>
          <Select
          style={{
            width: '35%',
              }}
            options={projectList}
            value={number}
            disabled={projectList.length >= 2 ? false : true}
            onChange={handleProjectChange}
          />
            </form>)}
            </div>
        <div className="w-[100%] h-[calc(100vh-141px)] overflow-y-auto">
            <Outlet/>
        </div>
      </div>
    </div>
  );
}

export default DashboardLayout;


